import React from 'react';
import { formatLedgerMoney } from '../../features/financeLedger';
import './ledgerImportAccounts.css';

const accountTypes = { cash: '現金', bank: '銀行', credit: '信用卡', ewallet: '電子錢包', other: '其他' };

export default function LedgerImportAccounts({ preview, choices = {}, onChange, currentLedger, disabled = false }) {
  if (!preview?.data || preview.kind === 'backup' || preview.errors?.length) return null;
  const existing = currentLedger?.accounts || [];
  const update = (id, key, value) => onChange({ ...choices, [id]: { ...choices[id], [key]: value } });
  if (!preview.accounts?.length) {
    return <p className="ledger-import-existing-note">這份檔案已對應到既有帳戶，沿用原本的帳戶類型與期初餘額。</p>;
  }
  return <section className="ledger-import-account-setup" aria-label="匯入帳戶設定">
    <h5>先確認帳戶</h5>
    <p>選擇建立新帳戶，或連到你已有的同幣別帳戶。既有帳戶的類型與期初餘額會保留。</p>
    <p>期初餘額是開始這份交易紀錄<strong>之前</strong>的餘額，不是現在餘額；信用卡欠款請填負數。</p>
    <div className="ledger-import-account-cards">
      {preview.accounts.map(account => {
        const choice = choices[account.id] || {};
        const targetId = choice.targetId === undefined ? 'new' : choice.targetId;
        const target = existing.find(item => item.id === targetId);
        return <fieldset className="ledger-import-account-card" disabled={disabled} key={account.id}>
          <legend>{account.name}<span>{account.currency}</span></legend>
          <label>對應帳戶
            <select aria-label={`${account.name} 對應帳戶`} value={targetId} onChange={event => update(account.id, 'targetId', event.target.value)}>
              <option value="new">建立新帳戶</option>
              {existing.filter(item => item.currency === account.currency).map(item => <option key={item.id} value={item.id}>{item.name}{item.archived ? '（已封存）' : ''}</option>)}
            </select>
          </label>
          {targetId === 'new' ? <div className="ledger-import-account-fields">
            <label>帳戶類型<select aria-label={`${account.name} 帳戶類型`} value={choice.type === undefined ? account.type : choice.type} onChange={event => update(account.id, 'type', event.target.value)}>
              {Object.entries(accountTypes).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
            </select></label>
            <label>期初餘額<input aria-label={`${account.name} 期初餘額`} type="number" step="0.01" value={choice.opening_balance === undefined ? account.opening_balance : choice.opening_balance} onChange={event => update(account.id, 'opening_balance', event.target.value)} /></label>
          </div> : <p className="ledger-import-account-retained">{target ? `沿用 ${target.name} · ${accountTypes[target.type]} · 原期初餘額 ${formatLedgerMoney(target.opening_balance, target.currency)}` : '請選擇仍存在的同幣別帳戶。'}</p>}
        </fieldset>;
      })}
    </div>
  </section>;
}
